var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSevenDays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "#FCD578"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0664 14.2246H14.1816V15.7539H12.0664V18.1445H10.4551V15.7539H8.33398V14.2246H10.4551V11.9336H12.0664V14.2246ZM20.9316 11.418L17.6328 19H15.8457L19.1504 11.8398H14.9082V10.4688H20.9316V11.418Z",
    fill: "#FCD578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSevenDays);
export default __webpack_public_path__ + "static/media/SevenDays.f509d66d2bcae1271344c82d7e6c642c.svg";
export { ForwardRef as ReactComponent };